@if (condition) {
  <div class="current-station-location-editor" [formGroup]="detailsFormGroup">
    <div class="row">
      <mat-form-field class="flex-grow" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.current-station-location-editor.location"></sc-dictionary-label>
        </mat-label>
        <mat-select formControlName="location" name="location">
          @for (location of locations; track location) {
            <mat-option [value]="location">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.current-station-location-editor.location.{{location}}"></sc-dictionary-label>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}
